<script>
import { mask } from 'vue-the-mask';
import { required } from 'vuelidate/lib/validators';
import {
  authComputed,
  authMethods,
  trainerMethods,
  adminPanelMethods,
} from '@state/helpers';

export default {
  components: {},
  directives: { mask },
  props: {},
  data() {
    return {
      couponTypes: [
        { label: 'Percent Off', value: 'percent' },
        { label: 'Amount Off', value: 'amount' },
      ],
      submitting: false,
      coupon: {
        name: '',
        type: '',
        amount: 0.0,
      },
    };
  },
  validations: {
    coupon: {
      name: {
        required,
      },
      amount: {
        required,
      },
      type: {
        required,
      },
    },
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...trainerMethods,
    ...authMethods,
    ...adminPanelMethods,
    submit() {
      this.submitting = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const couponObj = this.coupon;
        couponObj.type = this.couponTypes.find(
          (coupon) => coupon.label === couponObj.type
        ).value;
        this.createTrainerCoupon({
          trainerId: this.currentUser.trainer._id,
          couponObj: { coupon: couponObj },
        })
          .then(async (res) => {
            if (res.success) {
              this.coupon = { name: '', type: '', amount: 0.0 };
              this.addCoupon(res.coupon);
              this.setHideAdminPanel();
            } else {
              console.warn(res.message);
            }
            this.submitting = false;
          })
          .catch((err) => {
            console.warn(err);
            this.submitting = false;
          });
      } else {
        this.submitting = false;
      }
    },
    onCouponTypeChange(value) {
      this.coupon.type = value.label;
    },
  },
};
</script>

<template>
  <form @submit.prevent="submit">
    <div class="row">
      <div
        class="col"
        :class="[
          {
            'input-error': $v.coupon.name.$error,
          },
        ]"
      >
        <label>Coupon Name</label>
        <BaseInputText
          name="coupon-name"
          :value="coupon.name"
          placeholder="20% Off Forever"
          @input="coupon.name = $event.target.value"
        />
      </div>
    </div>
    <div class="row">
      <div
        class="col"
        :class="[
          {
            'select-error': $v.coupon.type.$error,
          },
        ]"
      >
        <label for="coupon-type">Coupon Type</label>
        <v-select
          :options="couponTypes"
          :searchable="false"
          :clearable="false"
          :value="coupon.type"
          @input="onCouponTypeChange"
        />
      </div>
    </div>
    <div class="row">
      <div
        class="col"
        :class="[
          {
            'input-error': $v.coupon.amount.$error,
          },
        ]"
      >
        <label
          >Coupon Amount
          <sub
            >({{
              coupon.type &&
              couponTypes.find((listCoupon) => listCoupon.label === coupon.type)
                .value === 'percent'
                ? 'Percent Off %'
                : '$ Amount Off'
            }})</sub
          ></label
        >
        <BaseInputText
          type="number"
          name="coupon-price"
          :value="coupon.amount"
          :placeholder="coupon.type === 'percent' ? '10%' : '$20.00'"
          min="1"
          step=".50"
          pattern="^\d*(\.\d{0,2})?$"
          @input="
            coupon.amount = $event.target.value
              ? parseFloat($event.target.value)
              : null
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <hr /><br />
        <BaseButton
          type="submit"
          class="btn btn-primary"
          :disabled="submitting"
        >
          {{ submitting ? 'Adding..' : 'Add Coupon' }}
        </BaseButton>
      </div>
    </div>
  </form>
</template>

<style lang="scss" scoped>
@import '@design';
.remove {
  background-color: $color-error-dark;
}
.select-error {
  border: 1px solid $color-error-dark;
}
</style>
